module.exports = __webpack_public_path__ + "img/9788954431460.5f75d78a.jpg";